import React from "react";
import { GoogleMap, MarkerF } from "@react-google-maps/api";

const MapPreview = ({ lat, lng, isLoaded, loadingText, showMarker }) => {
  if (!isLoaded)
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {loadingText}
      </div>
    );

  return (
    <GoogleMap
      mapContainerStyle={{ width: "100%", height: "100%" }}
      center={{ lat: lat, lng: lng }}
      zoom={showMarker ? 15 : 12}
      options={{
        disableDefaultUI: true,
        zoomControl: false,
        streetViewControl: false,
        mapTypeControl: false,
        draggable: showMarker,
      }}
    >
      {showMarker && <MarkerF position={{ lat: lat, lng: lng }} />}
    </GoogleMap>
  );
};

export default MapPreview;
